import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const sendBulkEmployeeInviteKey = 'sendBulkEmployeeInvite';

export interface SendBulkEmployeeInviteState {
  sendBulkEmployeeInviteResponse: any;
  sendBulkEmployeeInviteFailure: any;
  loaded: boolean;
}

export const initialState: SendBulkEmployeeInviteState = {
  sendBulkEmployeeInviteResponse: undefined,
  sendBulkEmployeeInviteFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.sendBulkEmployeeInvitationsSuccess, (state, action) => ({
    ...state,
    sendBulkEmployeeInviteResponse: action.response,
    loaded: true
  })),

  on(actions.sendBulkEmployeeInvitationsFailure, (state, action) => ({
    ...state,
    sendBulkEmployeeInviteFailure: action.error
  }))
);

export const sendBulkEmployeeInvite = (state: SendBulkEmployeeInviteState) => state.sendBulkEmployeeInviteResponse;
